export default "__VITE_ASSET__DZgHLiRY__"